module.exports = "https://coursera_assets.s3.amazonaws.com/images/8070b0e241a6905534b242584bd3aedf.png";